import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/landing/dist/king/@section2/index.js");
